<template>
  <div >
    <titleBar :title="title" :param="$route.query"/>
      <div class="innerCon">
        <div class="tip-earlyWarning mb10">
          {{ $t('此代金券默认支持全部计费类型适用于全部京东云产品')}}<br>
          {{ `2.${$t('有效时间根据具体合同要求限定有效期如有修改请联系具体渠道负责人')}`}}<br>
        </div>
        <div class="buildBox new-info border_top couponLoading">
          <div class="form-box">
            <div class="line-title mb20">{{ $t('代金券信息') }}</div>
              <jc-form :model="form" :rules="rules" ref="ruleForm" class="demo-ruleForm" label-width="100px" >
                <ul class="bank-lst" style="padding-left: 16px">
                  <li>
                    <jc-form-item :label="$t('可发放额度')">
                      <span>{{form.couponQuota}}</span>
                    </jc-form-item>
                 </li>
                  <li>
                    <jc-form-item :label="$t('代金券金额')"  prop="fee">
                      <jc-input :placeholder="$t('代金券金额不能超过可发放额度')"  v-model="form.fee" class="jc-input" style="width:420px"></jc-input>
                    </jc-form-item>
                  </li>
                  <li>
                    <jc-form-item :label="$t('有效时间')">
                      <span>{{form.time}}</span>
                    </jc-form-item>
                  </li>
                  <li>
                    <jc-form-item  class="couponLable" :label="`${$t('发放账号')}${$t('：')}`" prop="pointUser" label-width="104px">
                      <jc-input v-if="!restriction" :placeholder="$t('请输入用户账号')" v-model="form.pointUser" style="width:420px"></jc-input>
                      <div v-else >
                        <jc-button v-if="!form.pointUser" type="primary" @click="selectAccount">{{ $t('选择账号') }}</jc-button>
                        <div v-else>
                          <span style="padding-right:10px;">{{form.pointUser}}</span>
                          <jc-button type="primary" @click="selectAccount">{{ $t('重新选择') }}</jc-button>
                        </div>
                      </div>
                    </jc-form-item>
                  </li>
                  <li class="form-pdl7w mt40">
                    <jc-button @click="goBack">{{ $t('取消') }}</jc-button>
                    <jc-button type="primary" @click="submitForm">{{ $t('确定') }}</jc-button>
                  </li>
                </ul>
             </jc-form>

            </div>
          </div>
       </div>
      <jc-dialog :visible.sync="viewdeliverCoupon" size="tiny" :title="$t('发放代金券')" :modal-append-to-body='false' :close-on-click-modal="false">
        <div class="popup deliverLayer" style="padding:0">
        <ul class="listItem">
          <li>
            <p class="tit issueForm" >{{ $t('发放代金券金额') }}</p>
            <div class="con">
              {{`${form.fee} ${$t('元')}`}}
            </div>
          </li>
          <li>
            <p class="tit issueForm" >{{ $t('有效时间') }}</p>
            <div class="con">
              {{form.time}}
            </div>
          </li>
          <li>
            <p class="tit issueForm" >{{ `${$t('发放账号')}${$t('：')}`}}</p>
            <div class="con">
               {{form.pointUser}}
            </div>
          </li>
          <li>
            <p class="tit issueForm" ><span>{{ $t('验证码_') }}</span></p>
            <div class="con">
              <input type="text" class="inputMode book-w130" :placeholder="$t('请输入验证码')" v-model="form.verifyCode" maxlength="4" @blur="checkValid()"><img :src="verifyUrl" width="70" height="30"/> <a href="#" class="blueLink" @click.prevent="getVerifyCode" v-loading="codeload">{{ $t('看不清点击刷新') }}</a>
              <p class="new-tips">&nbsp;<span class="red" v-if="vertifyCodeErr">{{ $t('验证码输入有误') }}</span></p>
            </div>
          </li>
        </ul>
      </div>
      <p slot="footer" class="dialog-footer">
        <jc-button @click="viewdeliverCoupon=false">{{ $t('取消') }}</jc-button>
        <jc-button type="primary" @click="deliverCoupnEvt" class="diliverButton">{{ $t('确定') }}</jc-button>
      </p>
      </jc-dialog>
      <issue-account ref="issueAccount" @selectedName="selectedName"></issue-account>
    </div>
</template>

<script>
import getTranslation from '@/i18n/getTranslation'
import titleBar from '@/components/titleBar'
import { getTaskTime } from '@/utils/index'
import {
  pinValidate,
  deliverCoupon,
  queryQuota,
  getMobileCodeInfo,
  queryValidTime
} from '@/api/coupon-api.js'
import IssueAccount from '@/views/components/IssueAccount'
export default {
  name: 'createCoupon',
  data() {
    var COUPON_REG = /^([1-9][0-9]{0,8})(\.\d{1,2})?$|^0(\.\d{1,2})?$/
    var feeValidate = (rule, value, callback) => {
      if (!value) {
        return callback(new Error(getTranslation('请输入代金券金额')))
      } else {
        if (!Number(value)) {
          callback(new Error(getTranslation('代金券金额需大于0')))
        }
        if (parseFloat(this.form.couponQuota) < parseFloat(value)) {
          callback(new Error(getTranslation('代金券金额不能超过可发放额度')))
        } else {
          callback()
        }
      }
    }
    var userValidate = (rule, value, callback) => {
      setTimeout(async () => {
        if (this.restriction === 1) {
          return callback()
        }
        if (value === '') {
          return callback(new Error(getTranslation('请输入用户PIN')))
        }
        let _result = await pinValidate({ pointUser: value })
        let result = _result.body.result
        if (result.success) {
          let { data } = result
          if (data && data.validate === 0) {
            return callback(new Error(getTranslation('该用户PIN无效')))
          } else {
            return callback()
          }
        } else {
          return callback(result.message)
        }
      }, 400)
    }
    return {
      title: getTranslation('创建代金券'),
      couponLoading: false,
      viewdeliverCoupon: false,
      form: {
        couponQuota: 0.0,
        time: '',
        fee: '',
        pointUser: '',
        code: '',
        uid: '',
        verifyCode: ''
      },
      verifyUrl: `${process.env.BASE_URL}img/code.jpeg`,
      vertifyCodeErr: false,
      codeload: false,
      rules: {
        fee: [
          {
            required: true,
            message: getTranslation('请输入代金券金额'),
            trigger: 'blur'
          },
          {
            pattern: COUPON_REG,
            message: getTranslation(
              '代金券金额必须是大于或等于0的整数或小数，小数最多保留两位'
            ),
            trigger: 'blur'
          },
          { validator: feeValidate, trigger: 'blur' }
        ],
        pointUser: [
          {
            required: true,
            message: getTranslation('发放账号不能为空'),
            trigger: 'blur'
          },
          { validator: userValidate, trigger: 'blur' }
        ]
      },
      restriction: 0 // 是否限制发放用户，1限制，0不限制
    }
  },
  components: {
    titleBar,
    IssueAccount
  },
  methods: {
    goBack() {
      this.$router.push({ path: '/cost/coupon-limitation' })
    },
    submitForm() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.viewdeliverCoupon = true
          this.vertifyCodeErr = false
          this.getVerifyCode()
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    async deliverCoupnEvt() {
      this.vertifyCodeErr = false
      let { fee, pointUser, uid, verifyCode } = this.form
      let data = { fee, pointUser, uid, verifyCode }
      if (verifyCode && verifyCode.length === 4) {
        try {
          let _result = await deliverCoupon(data)
          let result = _result.body.result
          if (result.success) {
            this.$notify.success(getTranslation('发放成功'))
            this.$router.push({ path: '/cost/coupon-limitation' })
            this.viewdeliverCoupon = false
          } else if (!result.success && result.errorCode === 51002) {
            this.vertifyCodeErr = true
          } else {
            this.$notify.error(getTranslation('发放失败'))
            this.viewdeliverCoupon = false
          }
        } finally {
          this.getVerifyCode()
        }
      } else {
        this.vertifyCodeErr = true
      }
    },
    async queryQuota() {
      try {
        let _result = await queryQuota()
        this.couponLoading = false
        let result = _result.body.result
        // let { data } = result
        if (result.success) {
          if (result.permission == 3) {
            this.form.couponQuota = result.data || 0.0
            this.restriction = result.restriction || 0
          } else {
            this.$alert(
              getTranslation('您没有权限发放代金券'),
              getTranslation('提示')
            )
              .then(() => {
                this.$router.push({ path: '/cost/coupon' })
              })
              .catch(() => {
                this.$router.push({ path: '/cost/coupon' })
              })
          }
        } else {
          this.form.time = '--'
          this.$notify({
            message: result.message || getTranslation('数据加载失败'),
            type: 'error'
          })
        }
      } catch (err) {
        this.couponLoading = false
        this.$notify({
          message: getTranslation('数据加载失败'),
          type: 'error'
        })
      }
    },
    checkValid() {
      this.vertifyCodeErr =
        this.verifyCode === '' ||
        (this.verifyCode && this.verifyCode.length !== 4)
          ? true
          : false
    },
    // 获取验证码
    async getVerifyCode() {
      this.codeload = true
      this.form.verifyCode = ''
      let _result = await getMobileCodeInfo({ source: 'couponDeliver' })
      this.codeload = false
      if (_result && _result.body) {
        _result = _result.body
        if (_result.code == 0) {
          this.form.uid = _result.result.uid
          this.verifyUrl =
            '/v1/coupons/imgcode?uid=' +
            _result.result.uid +
            '&signature=' +
            _result.result.sign +
            '&source=' +
            _result.result.source +
            '&time=' +
            Math.random()
        } else {
          this.codeload = false
          this.$notify({
            message: getTranslation('获取验证码失败'),
            type: 'error'
          })
        }
      }
    },
    // 判断用户是否有发放代金券的权限
    async queryValidTime() {
      this.couponLoading = true
      try {
        let _result = await queryValidTime()
        this.couponLoading = false
        let result = _result.body.result
        let { data } = result
        if (result.success) {
          if (result.permission == 3) {
            this.queryQuota()
            if (data.type === 1) {
              this.form.time = `${data.validStartTime &&
                getTaskTime(data.validStartTime)}-${data.validEndTime &&
                getTaskTime(data.validEndTime)}`
            } else {
              this.form.time = `${data.relativeTime}${' ' +
                getTranslation('天')}`
            }
          } else {
            this.$alert(
              getTranslation('您没有权限发放代金券'),
              getTranslation('提示')
            ).then(() => {
              this.$router.push({ path: '/cost/coupon' })
            })
          }
        } else {
          this.form.time = '--'
          this.$notify({
            message: result.message || getTranslation('数据加载失败'),
            type: 'error'
          })
        }
      } catch (err) {
        this.couponLoading = false
        this.$notify({
          message: getTranslation('数据加载失败'),
          type: 'error'
        })
      }
    },
    selectAccount() {
      this.$refs.issueAccount.issueAccount = true
    },
    selectedName(val) {
      this.form.pointUser = val
      this.$refs.ruleForm.validate()
    }
  },
  created() {
    this.queryValidTime()
  }
}
</script>

<style scoped>
.form-pdl7w {
  padding-left: 110px;
}
.issueForm {
  width: 112px;
}

.tit.issueForm {
  padding-right: 5px;
}
</style>
